export const ALL_DASHES_REGEX = /-/g;
export const ALL_SPACES_OR_COMMAS_REGEX = /[ ,]+/;
export const SPACE_OR_COMMA_REGEX = /[ ,]/;
